import { createContext, useContext, useState, ReactNode } from 'react';

interface ResetConfirmationModalContextValue {
  showResetConfirmationModal: boolean;
  setShowResetConfirmationModal: (value: boolean) => void;
  openResetConfirmationModal: () => void;
  closeResetConfirmationModal: () => void;
}

export const ResetConfirmationModalContext = createContext<ResetConfirmationModalContextValue>({
  showResetConfirmationModal: false,
  setShowResetConfirmationModal: () => {
    /** no-op */
  },
  openResetConfirmationModal: () => {
    /** no-op */
  },
  closeResetConfirmationModal: () => {
    /** no-op */
  },
});

interface ResetConfirmationModalProviderProps {
  children: ReactNode;
}

export function ResetConfirmationModalProvider({ children }: ResetConfirmationModalProviderProps) {
  const [showResetConfirmationModal, setShowResetConfirmationModal] = useState<boolean>(false);

  const openResetConfirmationModal = () => setShowResetConfirmationModal(true);
  const closeResetConfirmationModal = () => setShowResetConfirmationModal(false);

  return (
    <ResetConfirmationModalContext.Provider
      value={{
        showResetConfirmationModal,
        setShowResetConfirmationModal,
        openResetConfirmationModal,
        closeResetConfirmationModal,
      }}
    >
      {children}
    </ResetConfirmationModalContext.Provider>
  );
}

export function useResetConfirmationModal() {
  return useContext(ResetConfirmationModalContext);
}
